import React, { Fragment, useEffect } from 'react'
import { InvalidFeedback, RepeaterItem } from './'
import { i18nText } from '../../../Services'
import './repeater.css'

export const Repeater = props => {
    const { context, element, modelPath } = props;

    const inputModel = context.readModel(modelPath, element.defaultValue || []);

    if (Array.isArray(inputModel.value) === false)
        inputModel.value = [];

    const validate = (array) => {
        const list = array || [...inputModel.value] || [];
        const messages = [];

        if (element.min && list.length < parseInt(element.min))
            messages.push({ name: "repeaterMin", type: "repeater", min: element.min, length: list.length });

        if (element.max && list.length > parseInt(element.max))
            messages.push({ name: "repeaterMax", type: "repeater", max: element.max, length: list.length });

        context.updateModel(modelPath, list, messages);
    }

    useEffect(() => {
        context.validators.subscribe(validate);
        return () => context.validators.unsubscribe(validate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context]);

    if (Array.isArray(inputModel.value) === false) {
        console.error(`Invalid element name : ${element ? element.name : ""}.\nThe repeater model value must be an array.\n`, element, "\n", inputModel);
        return null;
    }

    const onAdd = (e) => {
        const newArray = [...inputModel.value, {}];
        validate(newArray);
    }

    const onDelete = (e, item) => {
        let newArray = [...inputModel.value];
        newArray = newArray.filter(i => i !== item);
        validate(newArray);
    }

    return (
        <>
            <InvalidFeedback element={element} errors={inputModel.errors}></InvalidFeedback>
            <div className="repeater">
                <div className="repeater-body">
                    {inputModel.value.map((item, itemIndex) =>
                        <Fragment key={itemIndex}>
                            <div className="row repeater-title">
                                <div className="col">
                                    {element.title && <h3>{i18nText.getText(element.title)} {(itemIndex + 1)}</h3>}
                                </div>
                                {(!context.isReadOnly && !element.hideRemove) &&
                                    <div className="col col-4 repeater-title-buttons">
                                        <button type="button" className="btn btn-outline-secondary" onClick={(e) => onDelete(e, item)}>{i18nText.getText(element.deleteText)}</button>
                                    </div>
                                }
                            </div>
                            {element.elements.map((e, eindex) => <RepeaterItem key={eindex} {...props} element={e} modelPath={modelPath + `.[${itemIndex}]`}></RepeaterItem>)}
                        </Fragment>
                    )}
                </div>
                {(!context.isReadOnly && !element.hideAdd) &&
                    <div className="repeater-footer">
                        <button type="button" className="btn btn-primary" onClick={onAdd}>{i18nText.getText(element.addText)}</button>
                    </div>
                }
            </div>
        </>
    )
}